export default __webpack_public_path__ + "static/media/bg-pick-right.76f4e225.png";